import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  BrowserRouter,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import App from './App';
import Focus from "./pages/Focus/Focus.jsx";
import Feed from "./pages/Feed/Feed.jsx";
import Queue from "./pages/Queue/Queue.jsx"
import NotFound from "./pages/NotFound/NotFound.jsx";
import { AudioProvider } from './contexts/AudioContext'; // Adjust the import path as necessary
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react'


const REACT_APP_PUBLIC_POSTHOG_KEY="phc_m2COcUjncu1sFrAeSl0lnLpdPKk34W3Ux3vf3uv8d7p"
const REACT_APP_PUBLIC_POSTHOG_HOST='https://app.posthog.com'

const options = {
  api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
}

// seems like you can wrap the route components in an outlet within App
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Feed /> },
      { path: "feed", element: <Feed /> },
      { path: "feed/:sortBy", element: <Feed />},
      { path: "queue", element: <Queue /> },
      { path: "focus/:clipId", element: <Focus /> },
      { path: "*", element: <NotFound /> }
    ]
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PostHogProvider
    apiKey={REACT_APP_PUBLIC_POSTHOG_KEY}
    options={options}
  >
    <AudioProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AudioProvider >
  </PostHogProvider>
);

reportWebVitals();